import { render, staticRenderFns } from "./logoImg.vue?vue&type=template&id=f86baace&scoped=true"
import script from "./logoImg.vue?vue&type=script&lang=js"
export * from "./logoImg.vue?vue&type=script&lang=js"
import style0 from "./logoImg.vue?vue&type=style&index=0&id=f86baace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86baace",
  null
  
)

export default component.exports